import React, { useMemo } from 'react';
import WhereaboutsRow from "../user-row/WhereaboutsRow";
import { MemberMovements, WhereaboutsGroupType } from '@features/whereabouts/models/movements.models';
import { Column } from '../../../../atoms/StructuralLayout';
import { useSelector } from "react-redux";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { naturalSort } from '@shared/utils/ArrayUtils';
import { excludeUser } from '@features/whereabouts/models/whereaboutsScope';

interface Props {
  movements: MemberMovements[];
  enableSetMovements: boolean;
  groupId: WhereaboutsGroupType;
  // Set by views that render the signed-in user in their own section, so
  // they are not repeated inside the group list.
  excludeCurrentUser?: boolean;
}

export default function MovementsList(props: Props) {
  const {movements, enableSetMovements, excludeCurrentUser} = props;
  const currentUser = useSelector(selectCurrentUser);

  const filteredWhereaboutsList = useMemo(() => {
    const whereaboutsList = excludeCurrentUser ? excludeUser(movements, currentUser?.id) : movements.filter(Boolean);
    return naturalSort(whereaboutsList, 'fullName');
  }, [currentUser, movements, excludeCurrentUser]);

  return (
    <Column>
      {filteredWhereaboutsList.map((whereabouts: any, k: any) => (
        <WhereaboutsRow key={k} member={whereabouts}
                        enableSetMovements={enableSetMovements}
                        groupId={props.groupId}
                        currentUser={currentUser}/>
      ))}
    </Column>
  )
}
